export const countries = [
    { code: '+1', name: 'United States', flag: '🇺🇸', isoCode: 'US' },
    { code: '+1', name: 'Canada', flag: '🇨🇦', isoCode: 'CA' },
    { code: '+44', name: 'United Kingdom', flag: '🇬🇧', isoCode: 'GB' },
    { code: '+33', name: 'France', flag: '🇫🇷', isoCode: 'FR' },
    { code: '+49', name: 'Germany', flag: '🇩🇪', isoCode: 'DE' },
    { code: '+39', name: 'Italy', flag: '🇮🇹', isoCode: 'IT' },
    { code: '+34', name: 'Spain', flag: '🇪🇸', isoCode: 'ES' },
    { code: '+31', name: 'Netherlands', flag: '🇳🇱', isoCode: 'NL' },
    { code: '+32', name: 'Belgium', flag: '🇧🇪', isoCode: 'BE' },
    { code: '+41', name: 'Switzerland', flag: '🇨🇭', isoCode: 'CH' },
    { code: '+43', name: 'Austria', flag: '🇦🇹', isoCode: 'AT' },
    { code: '+45', name: 'Denmark', flag: '🇩🇰', isoCode: 'DK' },
    { code: '+46', name: 'Sweden', flag: '🇸🇪', isoCode: 'SE' },
    { code: '+47', name: 'Norway', flag: '🇳🇴', isoCode: 'NO' },
    { code: '+358', name: 'Finland', flag: '🇫🇮', isoCode: 'FI' },
    { code: '+351', name: 'Portugal', flag: '🇵🇹', isoCode: 'PT' },
    { code: '+30', name: 'Greece', flag: '🇬🇷', isoCode: 'GR' },
    { code: '+48', name: 'Poland', flag: '🇵🇱', isoCode: 'PL' },
    { code: '+420', name: 'Czech Republic', flag: '🇨🇿', isoCode: 'CZ' },
    { code: '+36', name: 'Hungary', flag: '🇭🇺', isoCode: 'HU' },
    { code: '+81', name: 'Japan', flag: '🇯🇵', isoCode: 'JP' },
    { code: '+82', name: 'South Korea', flag: '🇰🇷', isoCode: 'KR' },
    { code: '+86', name: 'China', flag: '🇨🇳', isoCode: 'CN' },
    { code: '+91', name: 'India', flag: '🇮🇳', isoCode: 'IN' },
    { code: '+65', name: 'Singapore', flag: '🇸🇬', isoCode: 'SG' },
    { code: '+852', name: 'Hong Kong', flag: '🇭🇰', isoCode: 'HK' },
    { code: '+853', name: 'Macau', flag: '🇲🇴', isoCode: 'MO' },
    { code: '+886', name: 'Taiwan', flag: '🇹🇼', isoCode: 'TW' },
    { code: '+66', name: 'Thailand', flag: '🇹🇭', isoCode: 'TH' },
    { code: '+60', name: 'Malaysia', flag: '🇲🇾', isoCode: 'MY' },
    { code: '+62', name: 'Indonesia', flag: '🇮🇩', isoCode: 'ID' },
    { code: '+63', name: 'Philippines', flag: '🇵🇭', isoCode: 'PH' },
    { code: '+84', name: 'Vietnam', flag: '🇻🇳', isoCode: 'VN' },
    { code: '+61', name: 'Australia', flag: '🇦🇺', isoCode: 'AU' },
    { code: '+64', name: 'New Zealand', flag: '🇳🇿', isoCode: 'NZ' },
    { code: '+55', name: 'Brazil', flag: '🇧🇷', isoCode: 'BR' },
    { code: '+52', name: 'Mexico', flag: '🇲🇽', isoCode: 'MX' },
    { code: '+54', name: 'Argentina', flag: '🇦🇷', isoCode: 'AR' },
    { code: '+56', name: 'Chile', flag: '🇨🇱', isoCode: 'CL' },
    { code: '+57', name: 'Colombia', flag: '🇨🇴', isoCode: 'CO' },
    { code: '+51', name: 'Peru', flag: '🇵🇪', isoCode: 'PE' },
    { code: '+27', name: 'South Africa', flag: '🇿🇦', isoCode: 'ZA' },
    { code: '+20', name: 'Egypt', flag: '🇪🇬', isoCode: 'EG' },
    { code: '+971', name: 'UAE', flag: '🇦🇪', isoCode: 'AE' },
    { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦', isoCode: 'SA' },
    { code: '+972', name: 'Israel', flag: '🇮🇱', isoCode: 'IL' },
    { code: '+90', name: 'Turkey', flag: '🇹🇷', isoCode: 'TR' },
    { code: '+7', name: 'Russia', flag: '🇷🇺', isoCode: 'RU' },
];

const regionDisplay = typeof Intl !== 'undefined' && typeof Intl.DisplayNames !== 'undefined'
    ? new Intl.DisplayNames(['en'], { type: 'region' })
    : null;

export const getCountryNameFromCode = (code) => {
    if (!code || typeof code !== 'string') {
        return '';
    }
    const normalized = code.trim().toUpperCase();
    if (regionDisplay) {
        try {
            const displayName = regionDisplay.of(normalized);
            if (displayName && displayName !== normalized.toLowerCase()) {
                return displayName;
            }
        } catch (err) {
            // fall back to normalized value
        }
    }
    return normalized;
};

export const getCountryFlag = (countryIdentifier) => {
    if (countryIdentifier == null) {
        return '🏳️';
    }

    if (Array.isArray(countryIdentifier)) {
        const first = countryIdentifier.find((value) => value != null && value !== '');
        return getCountryFlag(first);
    }

    if (typeof countryIdentifier === 'object') {
        const possible = countryIdentifier.countryCode || countryIdentifier.code || countryIdentifier.isoCode || countryIdentifier.country || countryIdentifier.name;
        if (!possible) {
            return '🏳️';
        }
        return getCountryFlag(possible);
    }

    const trimmed = String(countryIdentifier).trim();

    if (!trimmed) {
        return '🏳️';
    }

    if (/^[A-Za-z]{2}$/.test(trimmed)) {
        const upper = trimmed.toUpperCase();
        const codePoints = Array.from(upper).map(char => 0x1f1e6 + char.charCodeAt(0) - 65);
        return String.fromCodePoint(...codePoints);
    }

    let normalizedCountryName = trimmed.toLowerCase();

    const nameMap = {
        'uk': 'united kingdom',
        'gb': 'united kingdom',
        'us': 'united states',
        'usa': 'united states'
    };

    normalizedCountryName = nameMap[normalizedCountryName] || normalizedCountryName;

    const country = countries.find(c =>
        c.name.toLowerCase() === normalizedCountryName
    );
    return country ? country.flag : '🏳️';
};
